import React from 'react'
import I18n from 'resources/i18n/I18n'

const RPGDInfo = () => (
  <span
    dangerouslySetInnerHTML={{ __html: I18n.t('EventFilesSubtitle', { linkStart: '<a href="/rgpd" target="_blank">', linkEnd: '</a>' }) }}
    className="input-subtext-title"
  />
)

export default RPGDInfo
